import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const StatusMasterForm = () => {
    const [showStatusForm, setShowStatusForm] = useState(false);
    const [data, setData] = useState([]);
    const [edit, setEdit] = useState();

    // select field
    const [selectedStatus, setSelectedStatus] = useState(null);
    const status = [
        { name: 'Active', value: 1 },
        { name: 'In-Active', value: 2 },
        { name: 'Archive', value: 3 },
        { name: 'Reject', value: 4 },
        
    ];
    const data1 = [
        {
            statusNo: 1,
            statusName: 'Home Insurance',
            status: 1,
        },
        {
            statusNo: 2,
            statusName: 'Home Insurance',
            status: 2,
        },
        {
            statusNo: 3,
            statusName: 'Home Insurance',
            status: 3,
        }

    ]
    useEffect(() => {
        setData(data1);
    }, []);
    
    const statusView = (data) => {
        if(data.status == 1){ return( <div style={{color:"green"}}>Active</div> )}
        if(data.status == 2){ return( <div style={{color:"yellow"}}>In-Active</div> )}
        if(data.status == 3){ return( <div style={{color:"red"}}>Archive</div> )}
    };
    const formDialog = () => {
        setShowStatusForm(true);
    };
    const ActionBodyTemplate = (rowData, rowIndex) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" tooltip="Delete Status" tooltipOptions={{ position: "top" }} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary mr-2" tooltip="Edit Status" tooltipOptions={{ position: "top" }} onClick={() => { setEdit(true) }}></Button>
            </React.Fragment>
        );
    };


    return (
        <div>
            <h3>Status Master</h3>
            <Button className="pi pi-plus" onClick={() => formDialog()} >Create Status</Button>
            <Dialog visible={showStatusForm} onHide={() => setShowStatusForm(false)}>

                <form className="p-fluid p-grid">
                    <div className="p-field col-6">
                        <label htmlFor="username">Status Name</label>
                        <InputText id="username" aria-describedby="username-help" />
                        <label htmlFor="date"> Status Type</label>
                        <span>
                            <Dropdown
                                name="status"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.value)}
                                options={status}
                                optionLabel="name"
                                placeholder="Select ststus" />
                        </span>
                    </div>

                </form>

                <div style={{ float: 'right' }}>
                    <Button
                        type="button"
                        label="Cancel"
                        className="p-button-rounded p-default"
                        onClick={() => setShowStatusForm(false)}
                    />
                    <Button
                        type="submit"
                        label="Submit"
                        className="p-button-rounded"
                    />
                </div>
            </Dialog>
            <DataTable value={data}>
                <Column field="statusNo" header="S.NO"></Column >
                <Column field="statusName" header="Status Name"></Column >
                <Column field="status" header="Type" body={statusView}></Column >
                <Column header="Action" body={ActionBodyTemplate}></Column >
            </DataTable>
        </div>
    );
}
